module.exports = __webpack_public_path__ + "img/1543718673.a7327d5b.jpg";